<template>
  <div class="video-list">
    <div class="list-title">
      <div class="title-l">
        <i>+</i>
        <span>{{ list.title }}</span>
      </div>
      <img src="../../../assets/img/test/note.png" class="list-title-note" />
    </div>
    <ul class="list-sub">
      <li v-for="(item, index) in list.artChapterVideoDtos" :key="index">
        <span>{{ item.title }}</span>
        <div class="title-r">
          <em>{{ setTime(item.duration) }}</em>
          <img src="../../../assets/img/test/note-2.png" class="list-title-note" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "VideoList",
  props: ["data"],
  computed: {
    list() {
      return this.data;
    },
  },
  methods: {
    setTime(time, flag = false) {
      let m = parseInt((time / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(time % 60);
      s = s < 10 ? "0" + s : s;
      let str = `${m}:${s}`;
      if (flag) {
        str = `${m}分${s}秒`;
      }
      return str;
    },
  },
};
</script>

<style lang="scss">
.video-list {
  .list-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background-color: pink;
    margin-bottom: 32px;
    .title-l {
      i {
        display: inline-block;
        width: 17px;
        height: 17px;
        line-height: 14px;
        background-color: #2c3f52;
        border-radius: 50%;
        color: #fff;
        font-style: normal;
        font-size: 17px;
        text-align: center;
        margin-right: 11px;
      }
      span {
        line-height: 15px;
        font-size: 15px;
        color: #fff;
      }
    }
    .list-title-note {
      width: 20px;
      height: 15px;
    }
  }
  .list-sub {
    padding-left: 29px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 31px;
      line-height: 13px;
      span {
        display: inline-block;
        line-height: 13px;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.69);
      }
      .title-r {
        em {
          display: inline-block;
          line-height: 13px;
          font-size: 13px;
          color: #7f7f7f;
          margin-right: 6px;
        }
        .list-title-note {
          width: 15px;
          height: 13px;
          vertical-align: unset;
        }
      }
    }
  }
}
</style>
